import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { INavigationPath } from 'src/types/NavigationPath';

const initialState: INavigationPath = {
  navigationPathName: ''
};

export const navigationPath = createSlice({
  name: 'navigationPath',
  initialState,
  reducers: {
    clearPath: state => {
      state.navigationPathName = '';
    },
    setPath: (state, action: PayloadAction<any>) => {
      state.navigationPathName = action.payload;
    }
  }
});

export const { clearPath, setPath } = navigationPath.actions;
